import { useQuery } from "@apollo/client";
import constants from "src/constants";
import graphQLClient from "src/graphQL";
import { profiles } from "src/queries/profiles";
import { profilesHp } from "src/queries/profilesHp";

const defaultWhere = {
  blocked: false,
  private: false,
};

const homepageWhere = {
  blocked: false,
  private: false,
  id: constants.List.hpInstructors,
};

export default function useGetDataInstructors(
  lang?: string | null | undefined,
  search?: string,
  skip?: boolean,
  hp?: boolean
) {
  return useQuery(hp ? profilesHp : profiles, {
    variables: {
      sort: `slug:ASC`,
      where: {
        ...(hp ? homepageWhere : defaultWhere),
        ...(search ? { _q: search } : {}),
      },
    },
    errorPolicy: "all",
    skip,
  });
}

export async function getDataInstructors(): Promise<any> {
  const { data } = await graphQLClient.query({
    query: profiles,
    variables: { sort: "slug:ASC", where: defaultWhere },
    errorPolicy: "all",
  });

  return data.profiles;
}
